import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ICONE_EM_CONSTRUCAO } from '../navegacao/mapaDeNavegacao';

/**
 * O estado "ainda não construído" — EXPLÍCITO, nunca 404.
 *
 * A diferença importa: 404 diz "você errou o caminho" e faz a pessoa
 * duvidar de si. Esta tela diz "o caminho está certo, a tela ainda não
 * existe, e é isto que ela vai fazer". Uma dá culpa, a outra dá informação.
 */
export function AindaNaoConstruido({ titulo, promessa }: { titulo: string; promessa: string }): React.JSX.Element {
  const Icone = ICONE_EM_CONSTRUCAO;

  return (
    <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
      <Stack spacing={1.5} alignItems="center">
        <Icone sx={(tema) => ({ fontSize: 40, color: tema.palette.marca.pessego.borda })} />

        <Typography variant="h1">{titulo}</Typography>

        <Chip
          size="small"
          label="Ainda não construído"
          sx={(tema) => ({
            backgroundColor: tema.palette.marca.pessego.fundo,
            color: tema.palette.marca.pessego.tinta,
            border: `1px solid ${tema.palette.marca.pessego.borda}`,
            fontWeight: 600,
          })}
        />

        <Box sx={{ maxWidth: 560 }}>
          <Typography variant="body2" color="text.secondary">
            {promessa}
          </Typography>
        </Box>

        <Typography variant="caption" color="text.secondary">
          A rota existe e é esta. Quando a tela nascer, o endereço continua o mesmo.
        </Typography>
      </Stack>
    </Paper>
  );
}
